export const ExerciseSection = ({
    newExerciseName,
    setNewExerciseName,
    addExerciseLabel,
    exerciseList,
    removeExercise
}) => {
    return (
        <section>
            <div className="card p-6 mb-4">
                <p className="text-[11px] font-black text-slate-400 uppercase mb-3 px-1">운동 종목 관리</p>
                <div className="flex gap-2 mb-6">
                <input 
                    type="text" 
                    value={newExerciseName} 
                    onChange={(e) => setNewExerciseName(e.target.value)} 
                    className="flex-1 bg-slate-50 px-4 py-4 rounded-2xl border-none font-semibold" 
                    placeholder="새 운동 종목" 
                />
                <button onClick={addExerciseLabel} className="shrink-0 bg-slate-900 text-white px-5 rounded-2xl font-bold">추가</button>
                </div>
                <div id="exerciseLabelsContainer" className="flex flex-wrap gap-2">
                {exerciseList.map(ex => (
                    <div key={ex} className="bg-indigo-50 px-4 py-2 rounded-xl text-xs font-bold text-indigo-600 flex items-center gap-2">
                    {ex}
                    <span onClick={() => removeExercise(ex)} className="material-icons-round text-sm cursor-pointer">cancel</span>
                    </div>
                ))}
                </div>
            </div>
        </section>
    );
}